import moment from "moment";
import React from "react";
import { CalculateAge } from "../../function";
import { getUserdetails } from "../../Localstorage/localstorage";

const UserDashboardInfo = () => {
  const userdetails = getUserdetails();
  return (
    <div className="pb-4 mt-4 text-wa-text">
      <h1 className="text-2xl font-bold tracking-tight text-wa-text sm:text-3xl mb-6">
        Hallo, {userdetails?.full_name}{" "}
        <span className="text-base font-medium text-wa-muted sm:text-lg">{`(${CalculateAge(
          userdetails?.date_of_birth
        )} jaar)`}</span>
      </h1>

      <div className="rounded-lg border border-wa-border bg-wa-panel p-5 sm:p-8">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-wa-accent">
              Geregistreerd op
            </dt>
            <dd className="mt-1 text-sm text-wa-text">
              {moment(userdetails?.created_at).format("LLLL")}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
              Email address
            </dt>
            <dd className="mt-1 text-sm text-wa-text break-all">
              {userdetails?.email}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
              Klacht
            </dt>
            <dd className="mt-1 text-sm text-wa-text">{userdetails?.klacht}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
              Phone
            </dt>
            <dd className="mt-1 text-sm text-wa-text">
              {userdetails?.phone_number}
            </dd>
          </div>
          <div className="sm:col-span-2">
            <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
              Situatie
            </dt>
            <dd className="mt-1 text-sm text-wa-text whitespace-pre-wrap">
              {userdetails?.more_details}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default UserDashboardInfo;
